import * as React from "react";
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import wildlife_top from '../../src/assets/images/wildlife_top.png';
import wildlife_middle from '../../src/assets/images/wildlife_middle.png';

const Wildlife:React.FC = () => {
    return (
      <div>

      <Box
            component="img"
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
            src={wildlife_top}
            alt={"Wildlife"}
          />

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
            <Grid xs={12} sm={6} md={6}>
                <Card variant="outlined" sx={{ borderWidth: 0 }}>
                    <CardContent>
                        <Typography align="left" variant="h4">
                            Wildlife Clinic
                        </Typography>
                        <hr />
                        <Typography align="left" color="red" variant="h6">
                            CURRENT STATUS: Full capacity.  Not accepting new patients.
                        </Typography>
                        <hr />
                        <Typography align="left" variant="h6">
                            How We Can Help
                        </Typography>
                         <hr />

                         <Typography align="left" variant="body1">
                            <p>
                                Our Wildlife Clinic specializes 'rabies vector species' (RVS), which includes treating ill, injured, or orphaned raccoons, foxes, coyotes, skunks, bobcats, and bats.
                            </p>
                            <p>    
                                Our experienced Wildlife Rehabilitator - Chris Benson - is licensed by the Georgia Department of Natural Resources, and certified by the same for 'rabies vector species' (RVS).
                            </p>
                            <p>
                                For species that we do not address, or when we are at full capacity and unable to intake new patients, we try to help the (wildlife) finder by connecting them with an appropriate wildlife rehabilitator.
                            </p>
                            <p>
                                Our wildlife rehabilitation experts also provide free lifesaving guidance for resolving wildlife emergencies and human / wildlife conflicts.
                            </p>
                        </Typography>
                         <hr />
                        <Typography align="left" variant="h6">
                            How to contact the Animal Institute Wildlife Clinic
                        </Typography>
                         <hr />

                        <Typography align="left" variant="body1">
                            <p>
                                ALWAYS send an email to <strong><i>help@animalinstitute.org</i></strong> with <strong>ALL</strong> of the following information:
                            </p>
                        </Typography>
                        <Typography align="left" variant="body1">
                            <ul>
                                <li>First & last name</li>
                                <li>Cell phone number</li>
                                <li>Complete home street address</li>
                                <li>Complete street address / GPS coordinates of animal's point of origin</li>
                                <li>Email address that you actively monitor throughout the day</li>
                                <li>Details of your wildlife emergency or conflict, with a complete timeline that includes every decision and action taken</li>
                                <li>Detailed closeup photos</li>
                                <li>Availability to receive a phone call from an 'anonymous' / 'unknown' phone number (no caller id)</li>
                            </ul>
                        </Typography>

                        <Typography align="left" variant="h5">
                             <a href="mailto:help@animalinstitute.org">help@animalinstitute.org</a>
                        </Typography>

                        <hr />
                        <Typography align="left" variant="h6">
                            Injured, Ill, and Orphaned Wildlife
                        </Typography>
                         <hr />

                         <Typography align="left" variant="body1">

                            <p>
                                When you find a wild creature in need of assistance, first make sure it really needs assistance. Some usually do (baby squirrels), and some usually don’t (fawns). Don’t kidnap a perfectly healthy fawn left alone while its mother forages nearby, unless it is clearly sick or injured, and remember that you will likely never see the mom - so don’t panic. Newborn fawns that are in or by roadways should be picked up and placed 50-100 feet away to avoid a tragedy.
                            </p>
                            <p>
                                For a wild creature that is injured, ill, or orphaned, follow these three simple rules:
                            </p>
                            <ol>
                                <li>Keep it safe, secure, warm, quiet, dark, and away from people, pets, and predators. Do not handle more than absolutely necessary, because you are a giant predator to a wild animal, and unnecessary stress can kill. Having said that, a little of your scent on a baby will not make mom reject it, but minimize scent transfer by wearing exam gloves or similar.  Place a heating pad on low under (only) half of the container it is in, because babies and compromised adults may need help maintaining a healthy body temperature.</li>
                                <p />
                                <li>Do NOT feed or water. Nothing at all! Yes, it’s counterintuitive, but critically important! The websites you are getting your information from are often WRONG - but not this one.  ;-)</li>
                                <p />
                                <li>Do NOT post for help on social media. If you have already posted, please delete it. The comments you receive from supposedly experienced amateurs and wannabe rehabbers are often wrong - and frequently result in fatal outcomes with increased suffering.</li>
                                <p />
                                <li>Contact a licensed wildlife rehabilitator immediately - specifically one with expertise in the species. That person will provide all guidance and instruction thereafter.
                                    <p />
                                    Wildlife Rehabilitators (aka rehabbers) are licensed and regulated by state and federal laws and regulations. A person who is a legitimate wildlife rehabilitator can produce a current license to establish credentials.</li>
                            </ol>
                        </Typography>

                        <a id="other" />
                        <hr />
                        <Typography align="left" variant="h6">
                            Linked Resources For All Other Species
                        </Typography>
                         <hr />

                        <Typography align="left" variant="body1">
                            <p>
                                For other species not listed above, here are resources with which you can find a rehabber who specializes in the species you are seeking help for:
                            </p>
                        </Typography>

                        <Typography align="left" variant="body1">
                            <p>
                                <strong>Animal Help Now!</strong><br />
                                A website and mobile app that lists licensed wildlife rehabilitators. It covers the entire United States, not just Georgia. Highly recommended to keep on your phone.
                            </p>
                            <ul>
                                <li><a href="https://ahnow.org" target="_top">Animal Help Now!</a><br />(all species)</li>
                                <li><a href="https://apps.apple.com/us/app/animal-help-now/id511153457" target="_top">Animal Help Now!<br />iPhone app</a><br />(all species)</li>
                                <li><a href="https://play.google.com/store/apps/details?id=org.ahnow" target="_top">Animal Help Now!<br />Android / Google Play app</a><br />(all species)</li>
                            </ul>
                        </Typography>        


                        <Typography align="left" variant="body1">
                            <p>
                                <strong>Georgia Department of Natural Resources Wildlife Rehabilitators List (PDF)</strong><br />
                                Includes licensed wildlife rehabilitators who have opted-in to the ‘DNR public list’, but does not comprehensively list all licensed wildlife rehabilitators.
                            </p>
                            <ul>
                                <li><a href="https://gadnrle.org/sites/default/files/le/pdf/Special-Permits/WILDLIFE%20REHABILITATION%20%202023-2%20%20Q2%20Updates%20May.pdf" target="_top">Georgia Department of Natural Resources<br />Wildlife Rehabilitators List</a><br />(all species)</li>
                                <li><a href="https://gadnrwrd.maps.arcgis.com/apps/webappviewer/index.html?id=cfeac720835c407594b2407c4aefe32b" target="_top">Georgia Department of Natural Resources<br />Wildlife Rehabilitators Map</a><br />(all species)</li>
                            </ul>
                        </Typography>  
                                
                        <Typography align="left" variant="body1">
                            <p>
                                <strong>Wildlife Rehabilitators</strong>
                            </p>
                            <ul>
                                <li><a href="https://www.chattnaturecenter.org/visit/experience/wildlife" target="_top">Chattahoochee Nature Center Wildlife Clinic</a><br />(raptors, reptiles, and amphibians only)</li>
                                <li><a href="https://www.wildnestbirdrehab.org" target="_top">Wild Nest Bird Rehab</a><br />(songbirds / passerines only)</li>
                                <li><a href="https://www.waddleoninnrescue.org" target="_top">Waddle On Inn Rescue</a><br />(waterfowl only)</li>
                            </ul>
                        </Typography>  

                    </CardContent>
                </Card>
            </Grid>
            <Grid xs={12} sm={6} md={6}>
                    <Box
                            component="img"
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'none'
                            }}
                            src={wildlife_middle}
                            alt={"Wildlife"}
                        />
                
            </Grid>
        </Grid>
    </Box>
  </div>
    );
  };

  export default Wildlife;